import React from "react";

import _ from "lodash";

import { Header, Item, Table, Icon } from "semantic-ui-react";

import ApprovedReimbursementItem from "./ApprovedReimbursementItem";

import PendingPersonModal from "./PendingPersonModal";

const PendingSubmitterRow = props => {
  const person = props.person;
  const amountOwed = _.sumBy(person.pendingReimbursements, r => +r.amount);

  return (
    <PendingPersonModal
      person={person}
      trigger={
        <Table.Row>
          <Table.Cell>
            <Header as="h5">
              <Icon name="user" />
              <Header.Content>
                {person.name}
                <Header.Subheader>{person.email}</Header.Subheader>
              </Header.Content>
            </Header>
          </Table.Cell>
          <Table.Cell>
            <Item.Group>
              {person.pendingReimbursements.map((reimbursement, i) => (
                <ApprovedReimbursementItem
                  reimbursement={reimbursement}
                  key={i}
                />
              ))}
            </Item.Group>
          </Table.Cell>
          <Table.Cell>
            <Header as="h2" textAlign="center">
              ${amountOwed.toFixed(2)}
            </Header>
          </Table.Cell>
        </Table.Row>
      }
    />
  );
};

const PendingSubmitterTable = props => (
  <Table selectable={props.pendingPeople.length !== 0}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Person</Table.HeaderCell>
        <Table.HeaderCell>Reimbursements</Table.HeaderCell>
        <Table.HeaderCell textAlign="center">Owed</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {props.pendingPeople.map((person, i) => (
        <PendingSubmitterRow person={person} key={person.uuid} />
      ))}
      {props.pendingPeople.length === 0 && (
        <Table.Row>
          <Table.Cell colSpan="3">
            Hooray! No one is waiting for payment.
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
  </Table>
);

export default PendingSubmitterTable;



// WEBPACK FOOTER //
// ./frontend/src/components/PendingSubmitterTable.js